// local storage cart functionality

// TODO: During sales, change tm_localCart to tm_saleCart

const cart = {

  addItem: item => {
    if (typeof localStorage !== 'undefined') {
      const cartItems = cart.getCart()
      cartItems.push(item)
      localStorage.setItem('tm_localCart', JSON.stringify(cartItems))
    }
  },

  removeItem: item => {
    if (typeof localStorage !== 'undefined') {
      const cartItems = cart.getCart()
      const itemIndexInCart = getItemIndexInCart(cartItems, item)
      cartItems.splice(itemIndexInCart, 1)
      localStorage.setItem('tm_localCart', JSON.stringify(cartItems))
    }
  },

  incrementQuantity: (item, amount) => {
    if (typeof localStorage !== 'undefined') {
      const cartItems = cart.getCart()
      const itemIndexInCart = getItemIndexInCart(cartItems, item)
      cartItems[itemIndexInCart].quantity += amount
      localStorage.setItem('tm_localCart', JSON.stringify(cartItems))
    }
  },

  decrementQuantity: (item, amount) => {
    if (typeof localStorage !== 'undefined') {
      const cartItems = cart.getCart()
      const itemIndexInCart = getItemIndexInCart(cartItems, item)
      cartItems[itemIndexInCart].quantity -= amount
      localStorage.setItem('tm_localCart', JSON.stringify(cartItems))
    }
  },

  getCart: () => {
    if (typeof localStorage !== 'undefined')
      return JSON.parse(localStorage.getItem('tm_localCart')) || []
    else
      return []
  },

  getCartCount: () => {
    return cart.getCart().reduce((acc, item) => (acc + item.quantity), 0)
  },

  clearCart: () => {

  },
}

export default cart

const getItemIndexInCart = (cartItems, item) => {
  return cartItems.findIndex(i => i.variantId === item.variantId)
}
